<template>
	<div class="aside">
		<el-scrollbar style="height: 100vh;">
			<el-menu
			  :default-active="flag"
			  unique-opened
			  overflow-y: scroll
			  :default-openeds="open"
			  class="el-menu-vertical-demo"
			  background-color="#fff"
			  text-color="#303133"
			  active-text-color="#409eff"
			   :show-timeout=2000
			   @open="handleOpen" @close="handleClose" :collapse="isCollapse"
			  >
			  <!-- <el-menu-item index="/storehome" @click="todetail(111)" v-if="userPos === 'STORE' && vipLevel == 0">
				  <i class="iconfont icon-shouye tubiao"></i>
			    <span slot="title">{{$t('aside.home')}}</span>
			  </el-menu-item> -->
			  <el-menu-item index="/home" @click="todetail(13)" v-if="userPos === 'SELLER' && vipLevel == 0">
				  <i class="iconfont icon-shouye tubiao"></i>
			    <span slot="title">{{$t('aside.home')}}</span>
			  </el-menu-item>
			  <el-menu-item index="/index" @click="todetail(0)" v-if="userPos === 'SELLER' && vipLevel == 0">
				  <i class="iconfont icon-shouquan tubiao"></i>
			    <span slot="title">{{$t('aside.dianpusouquan')}}</span>
			  </el-menu-item>
			  <el-menu-item index="/sellerManagement" @click="todetail(104)" v-if="userPos === 'STORE' ">
				  <i class="iconfont icon-shouquan tubiao"></i>
			    <span slot="title">{{$t('aside.sellerManagement')}}</span>
			  </el-menu-item>
			  <el-menu-item index="/claimOrder" @click="todetail(24)" v-if="userPos === 'SELLER' && vipLevel == 0">
				  <i class="iconfont icon-suopeitiaojie tubiao"></i>
			    <span slot="title">{{$t('aside.claimAssistant')}}</span>
			  </el-menu-item>
			  <!-- 买家画像 -->
			  <!-- <el-menu-item index="/picture" @click="todetail(23)" v-if="userPos === 'SELLER' && vipLevel == 0">
			  		<i class="iconfont icon-kehuAx tubiao"></i>
			    <span slot="title"> {{$t('aside.Customer_Profile')}}</span>
			  </el-menu-item> -->

			  <el-menu-item index="/picture" @click="todetail(116)" v-if="userPos === 'SELLER' && vipLevel == 0">
			  		<i class="iconfont icon-kehuAx tubiao"></i>
			    <span slot="title"> {{$t('aside.zhenzifuwu')}}</span>
			  </el-menu-item>

			  <el-menu-item index="/transfer" @click="todetail(116)" v-if="userPos === 'STORE' ">
				  <i class="iconfont icon-kehuAx tubiao"></i>
			    <span slot="title"> {{$t('aside.zhenzifuwu')}}</span>
			  </el-menu-item>

			


			  <!-- 客服管理 -->
			  <el-submenu index="6"  v-if="userPos === 'SELLER' && vipLevel == 0">
			    <template slot="title">
			  		<i class="iconfont icon-kefu1 tubiao kvjhfm"></i>
			        <span> {{$t('aside.Customer_Service')}}</span>
			     </template>
				<!-- <el-menu-item class='children-item' index="/picture" @click="todetail(23)" >
					<span slot="title"> {{$t('aside.Customer_Profile')}}</span>
				</el-menu-item> -->
				<el-menu-item class='children-item' index="/chat" @click="todetail(21)" >
					<span slot="title"> {{$t('aside.SmartChat')}}</span>
				</el-menu-item>
				
				<el-menu-item class='children-item' index="/remind" @click="todetail(19)" >
					<span slot="title"> {{$t('aside.CaringSMS')}}</span>
				</el-menu-item>

				<el-menu-item class='children-item' index="/relevant" @click="todetail(34)" >
					<span slot="title"> {{$t('aside.Relevantquotation')}} </span>
				</el-menu-item>
				<!-- <el-menu-item class='children-item' index="/districhat" @click="todetail(66)" >
					<span slot="title">分销仓聊天</span>
				</el-menu-item> -->
			  </el-submenu>
			  <el-submenu index=1  v-if=" vipLevel == 0">
			    <template slot="title" >
				  <i class="iconfont icon-dingdan- tubiao"></i>
			      <span>{{$t('aside.wodedingdang')}}</span>
			    </template>
				<el-menu-item class='children-item'  index="/allOrders"   @click="todetail(11)" v-if="userPos === 'SELLER' ">{{$t('aside.allOrder')}}</el-menu-item>
				<el-menu-item class='children-item' index="/reviewOrders"    @click="todetail(112)" v-if="userPos === 'SELLER' ">{{$t('aside.shenghedang')}} </el-menu-item>
				<!-- <el-menu-item class='children-item' index="/pendingoreder"    @click="todetail(1)" v-if="userPos === 'SELLER' ">{{$t('aside.shenghedang')}}</el-menu-item> -->
				<el-menu-item class='children-item' index="/storePendingOrder" @click="todetail(6)">
				{{$t('aside.chulidang')}}eee
				 <span class="circle_box" v-show="remindNum !== 0"> {{remindNum}}</span>
				</el-menu-item>
				<el-menu-item class='children-item' v-if="userPos === 'STORE' " index="/precistDelivery" @click="todetail(32)">{{$t('aside.fenjianhedui')}}</el-menu-item>
				<el-menu-item class='children-item' v-if="userPos === 'STORE' " index="/package" @click="todetail(31)">{{$t('aside.daibaochuku')}}</el-menu-item>
				<el-menu-item class='children-item' index="/processed" @click="todetail(14)">{{$t('aside.processed')}}</el-menu-item>
				<el-menu-item class='children-item' index="/distrustOrder" v-show="userPos == 'STORE'"     @click="todetail(2)">
				{{$t('aside.tuhuanguanli')}}
				<span class="circle_box" v-show="toSellerProcess !== 0"> {{toSellerProcess}}</span>
				</el-menu-item>
				<el-menu-item v-if="userPos === 'SELLER' " class='children-item' index="/ReturnOrders"     @click="todetail(17)">
					{{$t('aside.Returned')}} <span style="font-size: 10px;color: orangered;" v-show="toSellerProcess !== 0"> {{$t('other.a1064')}}：{{toSellerProcess}}</span>
				</el-menu-item>
				<el-menu-item v-if="userPos === 'SELLER' " class='children-item' index="/complaint" @click="todetail(27)">{{$t('homeTwo.OverseasWarehouseComplaintCenter')}}</el-menu-item>
				<el-menu-item v-if="userPos === 'STORE'" class='children-item' index="/complaintStore" @click="todetail(33)">{{$t('homeTwo.OverseasWarehouseComplaintCenter')}}</el-menu-item>
			  </el-submenu>
			  <el-submenu index="/mygoods" v-if="userPos === 'SELLER' ||  vipLevel == 1 ">
			    <template slot="title">
				  <i class="iconfont icon-cangku1 tubiao"></i>
			      <span> {{$t('other.a1065')}}</span>
			    </template>
				<!-- <el-menu-item class='children-item' index="/mygoods" v-if="userPos === 'SELLER' && vipLevel == 0"  @click="todetail(101)" >线上产品</el-menu-item> -->
			  	<el-menu-item class='children-item' index="/stockProduct/single"  @click="todetail(101)" >{{$t('stockProduct.singlePro')}}</el-menu-item>
			    <el-menu-item class='children-item' index="/stockProduct/combo" @click="todetail(106)"  > {{$t('stockProduct.combo')}}</el-menu-item>
				<el-menu-item class='children-item' index="/stockProduct/gift" @click="todetail(107)"  >{{$t('stockProduct.gift')}}</el-menu-item>
				<!-- <el-menu-item class='children-item' index="/stockProduct/storeTasks" @click="todetail(116)" >任务管理</el-menu-item> -->
			  </el-submenu>

			  <!-- 入库管理 -->
			  <el-submenu index="/sellerpurchase" v-if="userPos === 'SELLER' && vipLevel !== 1">
			    <template slot="title">
			  		<i class="iconfont icon-ruku tubiao"></i>
			        <span>{{$t('aside.rukuguangli')}}</span>
					<span v-show="purchaseOrderNum !== 0" class="cirle">{{purchaseOrderNum}}</span>
			    </template>
				<el-menu-item class='children-item' index="/createpurchasing"  @click="todetail(108)" >采购管理</el-menu-item>
			  	<el-menu-item class='children-item' index="/PurchaseStorage"  @click="todetail(16)" >{{$t('aside.CreatList')}}</el-menu-item>
			    <el-menu-item class='children-item' index="/sellerpurchase" @click="todetail(4)"  v-if="userPos === 'SELLER'"> 
					<span>{{$t('aside.AllLists')}}</span>
					<span style="font-size: 10px;color: orangered;" v-show="purchaseOrderNum !== 0"> 待卖家处理:{{purchaseOrderNum}}</span>
				</el-menu-item>
				<el-menu-item class='children-item' index="/sellerorder"  @click="todetail(103)" >转 仓 单</el-menu-item>
			  </el-submenu>
			  <!-- <el-menu-item index="/createpurchasing"  @click="todetail(108)" v-if="vipLevel == 4">
               <i class="iconfont icon-fenxiaopingtai tubiao"></i>
              采 购 单</el-menu-item> -->
				<el-menu-item index="/createpurchasing"  @click="todetail(108)" v-if="vipLevel == 4">
			   <i class="iconfont icon-fenxiaopingtai tubiao"></i>
			  采 购 单</el-menu-item>
			  <el-menu-item index="/distributeProduct" @click="todetail(105)"  v-if="userPos === 'SELLER' && vipLevel == 1">
				  <i class="iconfont icon-fenxiaopingtai tubiao"></i>
			    <span slot="title"> {{$t('other.a1530')}} </span>
			  </el-menu-item> 
			  <el-menu-item index="/createpurchasing"  @click="todetail(108)" v-if="userPos === 'SELLER' && vipLevel == 1">
			   <i class="iconfont icon-fenxiaopingtai tubiao"></i>
			  采 购 单
			  </el-menu-item>


			  <!-- v-if="userPage.page1 == true"  分 销 平 台-->
			  <!-- <el-menu-item index="/distributeProduct" @click="todetail(25)" v-if="userPos === 'SELLER' && vipLevel !== 1" >
				<i class="iconfont icon-fenxiaopingtai tubiao"></i>
			    <span slot="title"> 分 销 平 台</span>
			  </el-menu-item> -->

			  <el-submenu index="/distributeProduct"  v-if=" vipLevel == 0 && userPos === 'SELLER' " >
			    <template slot="title" >
				  <i class="iconfont icon-fenxiaopingtai tubiao"></i>
			      <span> 分 销 平 台</span>
			    </template>
				<el-menu-item class='children-item'  index="/distributeProduct/community"   @click="todetail(113)" v-if="userPos === 'SELLER' ">本 土 货 源</el-menu-item>
				<el-menu-item class='children-item'  index="/distributeProduct/myselfproduct"   @click="todetail(114)" v-if="userPos === 'SELLER' ">我 的 供 货</el-menu-item>
				<el-menu-item class='children-item'  index="/distributeProduct/hasAgent"   @click="todetail(115)" v-if="userPos === 'SELLER' ">{{$t('other.a1781')}}</el-menu-item>
			  </el-submenu>







			  
			  
			  <!-- 商品采集 -->
			  <el-submenu index="9" v-if="userPos === 'SELLER' && vipLevel !== 1">
			    <template slot="title">
			  		<i class="iconfont icon-shangpincaiji tubiao"></i>
			        <span> 产 品 开 发</span>
			    </template>
				<el-menu-item class='children-item' index="/collection" @click="todetail(26)"  >
					<span slot="title">产品采集</span>
				</el-menu-item>
				<el-menu-item class='children-item' index="/productLibrary"  @click="todetail(109)" >产品待审</el-menu-item>
				<el-menu-item class='children-item' index="/templateManagement" @click="todetail(22)" >
					<span slot="title">{{$t('other.a2805')}}</span>
				</el-menu-item>
				
				<!-- <el-menu-item class='children-item' index="/manuallycreate"  @click="todetail(110)" >手动创建产品</el-menu-item> -->
			  </el-submenu>

			 
			  <el-menu-item index="/group" @click="todetail(15)" v-if="userPos === 'SELLER' && vipLevel == 0">
			  		<i class="iconfont icon-yunying tubiao"></i>
			    <span slot="title"> {{$t('aside.Management')}}</span>
			  </el-menu-item>
			  
			  <el-menu-item index="/recharge" @click="todetail(12)" v-if="userPos === 'SELLER' && vipLevel == 0">
			  		<i class="iconfont icon-chongzhizhongxin tubiao"></i>
			    <span slot="title"> {{$t('aside.recharge')}}</span>
			  </el-menu-item>
			  <el-menu-item index="/storepurchase" @click="todetail(5)" v-if="userPos === 'STORE' ">
				  <i class="iconfont icon-cangku1 tubiao"></i>
			    <span slot="title">{{$t('aside.kuchuguanli')}}</span>
			  </el-menu-item>
			  <el-menu-item index="/godownentry" @click="todetail(9)" v-if="userPos === 'STORE' ">
				  <i class="iconfont icon-ruku tubiao"></i>
					<span slot="title">
						{{$t('aside.godownentry')}}
						<span class="circle_box" v-show="purchaseOrderNum !== 0"> {{purchaseOrderNum}}</span>
					</span>
			  </el-menu-item>
			  <el-menu-item index="/transfer" @click="todetail(102)" v-if="userPos === 'STORE' ">
				  <i class="iconfont icon-ruku tubiao"></i>
				  <span slot="title">{{$t('aside.zhuanchuandan')}}</span>
			  </el-menu-item>


			  <!--邀请有奖 -->
			  <!-- <el-submenu index="/registrationlink" v-if="vipLevel == 0  && userPos == 'SELLER' " >
			    <template slot="title">
			  		<i class="iconfont icon-jiamengyouli tubiao"></i>
			        <span> {{$t('homeTwo.invitecashback')}}</span>
			    </template>
				<el-menu-item class='children-item' index="/registrationlink"  @click="$router.push({path:'/registrationlink'})" >专属邀请链接</el-menu-item>
			  	<el-menu-item class='children-item' v-show="!isShopsooo" index="/ppp"  @click="todetail(36)" >邀请分享页</el-menu-item>
			  </el-submenu> -->
			  
			  <!-- <el-menu-item  @click="todetail(36)" v-if="vipLevel == 0 && !isParnet && userPos == 'SELLER' && !isShopsooo">
				  <i class="iconfont icon-jiamengyouli tubiao"></i>
					<span slot="title">
						{{$t('homeTwo.invitecashback')}}
					</span>
			  </el-menu-item> -->
			</el-menu>
		</el-scrollbar>
		    
	</div>	
</template>

<script>
	import { mapState, mapActions, mapMutations} from 'vuex'
	import orderApi from '../../api/moudles/order'
	import newOrders from '@/api/moudles/newOrders'
	import api from '../../api/api'
	import shopaccessApi from '../../api/moudles/shopaccess'
	import utils from '../../utils/utils.js'
	import jsonp from '../../api/jsonp'
// import { resolve } from 'dns'
	export default{
		data() {
			return {
				userPage:{
					page1:false,
					page2:false
				},
				btnlist:[
					'店铺授权',
					'我的订单',
					'我的商品',
					this.$t('other.a1923'),
				],
				currentSort:0,
				newUrl:'',
				flag:'',
				ttp:'',
				open:['1'],
				purchaseOrderNum:0,
				remindNum:0,
				toSellerProcess:0,
				isShopsooo:JSON.parse(localStorage.getItem('isShopsooo'))
				
				
				
				
			}
		},
		computed:{
			...mapState({
				userId: state=>state.login.userInfo.userId || '',
				shopList: state => state.shopaccess.shopInfo || '',
				isParnet: state => state.shopaccess.isParnet || '',
				warehouse: state => state.shopaccess.warehouse || '',
				userPos: state=>state.login.userInfo.userPos || '',
				vipLevel: state=>state.login.userInfo.vipLevel || '',
				// toSellerProcess:state => state.order.toSellerProcess,
				toStoreProcess:state => state.order.toStoreProcess,
				// purchaseOrderNum:state => state.sellerpurchase.purchaseOrderNum,
				isCollapse:state => state.common.isCollapse,
			}),
			
		
			
		},
		watch:{
			$route(){
				// alert(this.$route.path)
				this.flag=this.$route.path
				
			}
		},
		mounted(){
			this.init()
			this.queryRemindNum()
		},
		methods:{
			
			...mapActions('order', [
				'getProblemorder',
				'queryReturnOrderNum'
				
				
			]),

				...mapActions('sellerpurchase', [
				'getPurchaseOrderNum',
				
				
			]),

			...mapMutations('shopaccess', [
			'SET_STORAGE_TTP',
			'GET_LAZADA_SHOP',
			'DELET_HAS_CLAIM_ALL'
				
		]),

		
		handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
		opencollapse(){
			this.isCollapse = true
		},
		closecollapse(){
			this.isCollapse = false
		},
		
			
			init(){
				setTimeout(() => {
					this.flag=this.$route.path
				},500)
				
				if(JSON.parse(localStorage.getItem('userInfo')).userPage){
					this.userPage=JSON.parse(localStorage.getItem('userInfo')).userPage
				}
				console.log(this.userPage)
				
				// this.getPurchaseOrderNum({userId:this.userId})
				// this.queryReturnOrderNum({userId:this.userId})
				
				
			},

			queryRemindNum(){
				newOrders
				.queryRemindNum({userId:this.userId})
				.then(res => {
				if(res.code === 200 ){
				console.log('desc',res.data)
				this.purchaseOrderNum=res.data.purchaseNum//入库单数量
				this.toSellerProcess=res.data.returnNum//待卖家处理退货订单数量
				this.remindNum=res.data.remindNum

				}else{
				this.$message.warning(res.msg)
				}
				})
			},
			
			  getUserDetail(){
			  shopaccessApi
			  .getUserInfo({userId:JSON.parse(localStorage.getItem('userInfo')).userId})
			  .then(res => {
				  if(res.code === 200){
					 
					  this.DELET_HAS_CLAIM_ALL(res.data)
					  let data=res.data
					    if(data.shopeeShops || data.lazadaShops || data.tiktokShops){
							localStorage.setItem('shophasAuthorization', true)
						}else{
							localStorage.setItem('shophasAuthorization', false)
						}
						if(data.userPos=== 'STORE'){
							localStorage.setItem('shophasAuthorization', true)
						}
						this.GET_LAZADA_SHOP(data.lazadaShops)
						localStorage.setItem('userInfo', JSON.stringify(data))
						localStorage.setItem('shopIdInfo', JSON.stringify(data.shopeeShops))
						localStorage.setItem('warehouse', JSON.stringify(data.stores))
						localStorage.setItem('lazadashopId', JSON.stringify(data.lazadaShops))
						localStorage.setItem('temuAuth', JSON.stringify(data.temuAuth))
				  } 
			  })
		  },
			todetail(num){
				let viplevel=JSON.parse(localStorage.getItem('userInfo')).vipLevel
				this.getUserDetail()
				if(num === 0) {
					this.$router.push({path:'/index'})
				}else if(num === 1) {
					this.$router.push('/pendingoreder')
			
				}else if(num === 2) {
					this.$router.push('/distrustOrder')
				}else if(num === 3) {
					this.$router.push('/mygoodsTab')
				}else if(num === 4) {
					this.$router.push('/sellerpurchase')
				}else if(num === 5) {
					this.$router.push('/storeManagement/single')
				}else if(num === 6) {//待处理页面
					if(this.userPos == 'STORE'){
						this.$router.push('/storePendingOrder')
					}
					if(this.userPos == 'SELLER'){
						this.$router.push('/notHandle')
					}
				}else if(num === 7) {
					this.$router.push('/problemorder')
				}else if(num === 8) {
					this.$router.push('/userStoreItems')
				}else if(num === 9) {
					this.$router.push('/godownentry')
				}else if(num === 10) {
					this.$router.push('/binditems')
				}else if(num === 11) {
					this.$router.push({path:'/allOrders'})
				}else if(num === 12) {
					this.$router.push('/recharge')
				}else if(num === 13) {
					this.$router.push('/home')
				}else if(num === 14) {
					if(this.userPos == 'STORE'){
						this.$router.push('/processedOrder')
					}
					
					if(this.userPos == 'SELLER'){
						this.$router.push('/processedSeller')
					}
				}else if(num === 15) {
					this.$router.push('/group')
				}else if(num === 16) {
					this.$router.push('/factorysupply/inbound')
				}else if(num === 17) {
					this.$router.push('/ReturnOrders')
				}else if(num === 19){
					this.$router.push('/remind')
				}else if(num ===18){
					this.$router.push('/discountShopee')
				}else if(num === 20){
					this.$router.push('/alliance/singleGoods')
				}else if(num === 21){
					this.$router.push('/chat')
				}else if(num === 22){
					this.$router.push('/templateManagement')
				}else if(num === 23){
					this.$router.push('/picture')
				}else if(num === 24){
					this.$router.push('/claimOrder')
				}else if(num === 25){
					this.$router.push('/distributeProduct/community')
				}else if(num === 26){
					this.$router.push('/collection')
				}else if(num === 27){
					this.$router.push('/complaint')
				}else if(num === 28){
					this.$router.push('/notHandle')
				}else if(num === 29){
					this.$router.push('/storePendingOrder')
				}else if(num === 30){
					this.$router.push('/processedOrder')
				}else if(num === 31){
					
					let shopeePlatform=true
					localStorage.setItem('shopee',JSON.stringify(shopeePlatform))
					let router = this.$router.resolve(
					{ 
						name: "package" ,
					}
					)
					window.open(router.href, '_blank');
				}else if(num === 32){
					let shopeePlatform=true
					localStorage.setItem('shopee',JSON.stringify(shopeePlatform))
					let router = this.$router.resolve(
					{ 
						name: "precistDelivery" ,
					}
					)
				
					window.open(router.href, '_blank');
				}else if(num == 33){
					this.$router.push('/complaintStore')
				}else if(num == 34){
					this.$router.push('/relevant')
				}else if(num == 66){
					this.$router.push('/districhat')
				}
				else if(num == 35){
					this.$router.push('/urgentprocessing')
				}else if(num == 36){
					newOrders
					.getUserInviteCode({userId:this.userId})
					.then(res => {
					if(res.code === 200 ){
					console.log('desc',res.data)
					
					window.open('https://i.shopsbu.com/?invitationCode=' + res.data.invitationCode )
				
					}else{
					this.$message.warning(res.msg)
					}
					})

				}else if(num == 100) {

					
					if(utils.judgePcOrAndirod()){
						this.$router.push({
							path:'/mh5/distributionStore',
							query:{
								userId:this.userId,
								userName:JSON.parse(localStorage.getItem('userInfo')).userName
							}
						})
					}else{
						this.$router.push({
							path:'/mh5/distributionStore',
							query:{
								userId:this.userId,
								userName:JSON.parse(localStorage.getItem('userInfo')).userName
							}
						})
					}
				}else if(num == 101){
					this.$router.push({
							path:'/stockProduct/single',
						})
				}else if(num == 102){
					this.$router.push({
						path:'/transfer',
					})
				}else if(num == 103){
					this.$router.push({
						path:'/sellerorder',
					})
				}else if(num == 104){
					this.$router.push({
						path:'/storehome',
					})
				}else if(num == 105){
					this.$router.push({
						path:'/factorysupply/stcokGoods',
					})
				}else if(num == 106){
					this.$router.push({
							path:'/stockProduct/combo',
						})
				}else if(num == 107){
					this.$router.push({
					path:'/stockProduct/gift',
				})
				}else if(num == 108){
					this.$router.push({
					path:'/factorysupply/createpurchasing',
				})
				}else if(num == 109){
					this.$router.push({
					path:'/factorysupply/productLibrary',
				})
				}else if(num == 110){
					this.$router.push({
					path:'/factorysupply/manuallycreate',
				})
				}else if(num == 111){
					this.$router.push({
					path:'/storehome',
				})
				}else if(num == 112){
					this.$router.push({
						path:'/reviewOrders',
					})
				}else if(num == 113){
					this.$router.push({
						path:'/publicGoods',
					})
				}else if(num == 114){
					this.$router.push({
						path:'/myselfproduct/goods',
					})
				}else if(num == 115){
					this.$router.push({
						path:'/hasAgent',
					})
				}else if(num == 116){
					this.$router.push({
						path:'/stockProduct/storeTasks',
					})
				}


				
			},
		}
	}
</script>

<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }
.aside{
	position: fixed;
    top:50px;
	display: flex;
	/* width: 220px; */
	height: 100vh;
	flex-direction: column;
	/* border-right: 1px #eee solid; */
	background-color: #fff;
	font-family: "PingFang SC";
}	

.aside .el-menu-vertical-demo {
	
	padding-bottom: 150px;
	
}
.aside .el-menu-item{
	font-size: 20px !important;
}

.tubiao{
	font-size: 20px!important;
	padding-right: 5px ;
}

.aside .el-submenu__title{
	font-size: 20px !important;
	
}
.aside .children-item{
	border-bottom: 1px solid #C0C4CC;
	font-size: 16px !important;
	padding-left: 32px !important;
	
	
}

.aside .kvjhfm{
	color: red;
}

.aside .el-submenu__title{
	position: relative;
	
}

.aside .circle_box{
	display: inline-block;
	width:20px;
	height: 20px;
	line-height: 20px;
	background: orangered;
	border-radius: 50%;
	color: #ffffff;
	box-sizing: border-box;

	font-size: 10px;
	text-align: center;
}


   

.aside .cirle{
		position: absolute;
		top: 23px;
		right: 32px;
		display: block;
		width: 15px;
		height: 15px;
		background-color: red;
		border-radius: 50%;
		text-align: center;
		line-height: 15px;
		font-size: 6px;
		color: #fff;
}

	
</style>
